export const validateCustomerForm = values => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Can\'t be blank';
  }

  if (!values.phone) {
    errors.phone = 'Can\'t be blank';
  }

  if (!values.address) {
    errors.address = 'Can\'t be blank';
  }

  return errors;
};

export const validateProductForm = values => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Can\'t be blank';
  }

  if (!values.price) {
    errors.price = 'Can\'t be blank';
  } else if (isNaN(parseFloat(values.price))) {
    errors.price = 'Should be a number';
  } else if (values.price < 1) {
    errors.price = 'Should be a positive number and bigger than 0';
  }

  return errors;
};

export const validateInvoiceForm = values => {
  const errors = {};

  if (!values.discount) {
    errors.discount = 'Can\'t be blank';
  }

  return errors;
};

export const validateLoginForm = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (!values.password) {
    errors.password = 'Required';
  } else if (values.password.length < 6) {
    errors.password = 'Sorry, password should be at least 6 chars';
  }
  return errors;
};



// WEBPACK FOOTER //
// ./src/utils/validator.js